import React from 'react';

const Footer = () => {
  return (
    <div>
      <footer className="footer p-4 bg-white text-black text-center border-t border-gray-300 flex justify-center">
        © 2025 Muhammed Jahsid. muhammedjahsid@gmail.com. All rights reserved.
      </footer>
    </div>
  );
};

export default Footer;